import React, { useEffect, useState } from 'react';
import { translate } from '../../../Services/translation';

interface MyPagesRmaRowCommentBoxProps {
  value?: string;
  onChange: (comment: string) => void;
}

const MyPagesRmaRowCommentBox = ({
  value,
  onChange,
}: MyPagesRmaRowCommentBoxProps) => {
  const [comment, setComment] = useState(value ?? '');

  useEffect(() => {
    setComment(value ?? '');
  }, [value]);

  return (
    <textarea
      className="p-2 text-sm"
      value={comment}
      onChange={(e) => setComment(e.target.value)}
      onBlur={(e) => onChange(e.target.value)}
      placeholder={translate('mypage.rma.reason')}
    />
  );
};

export default MyPagesRmaRowCommentBox;
